import React from 'react';
import { useTrusteeContext } from '../../context';
import { cardType, cardTypeName, } from '../../../common/interfaces';
import ContactDetails from '../../../common/views/contactDetails/contactDetails';
var getFields = function (fields) { return [
    {
        type: 'phone',
        name: 'telephoneNumber',
        label: fields.telephone.label,
        inputWidth: 2,
        cfg: { mb: 3 },
        required: true,
        errorEmptyValue: fields.telephone.error.empty,
        errorInvalidValue: fields.telephone.error.invalid,
    },
    {
        type: 'email',
        name: 'emailAddress',
        label: fields.email.label,
        inputWidth: 6,
        required: true,
        errorEmptyValue: fields.email.error.empty,
        errorInvalidValue: fields.email.error.invalid,
    },
]; };
export var Contacts = function () {
    var _a;
    var _b = useTrusteeContext(), current = _b.current, send = _b.send, i18n = _b.i18n;
    var _c = current.context, trustee = _c.trustee, loading = _c.loading;
    var fields = getFields((_a = i18n === null || i18n === void 0 ? void 0 : i18n.contacts) === null || _a === void 0 ? void 0 : _a.fields);
    var onSubmit = function (values) {
        send('SAVE', { values: values });
    };
    return (React.createElement(ContactDetails, { type: cardType.trustee, typeName: cardTypeName.trustee, title: i18n.contacts.title, subtitle: i18n.contacts.subtitle, sectionTitle: i18n.contacts.sectionTitle, loading: loading, onSubmit: onSubmit, initialValues: {
            telephoneNumber: trustee.telephoneNumber,
            emailAddress: trustee.emailAddress,
        }, fields: fields }));
};
//# sourceMappingURL=index.js.map